<template>
  <div>
    <div class="page-heading">
      <h2>
        {{ $I18n.t('calendario_guardias') }}
        <a
          href="/eventos"
          class="btn btn-sm btn-default pull-right"
        >
          <i class="fa fa-calendar-alt"></i> {{ $I18n.t('Agenda') }}
        </a>
        <a
          v-if="accesoDisponibilidad"
          href="/guardias/disponibilidades"
          class="btn btn-sm btn-default pull-right m-r-xs"
        >
          <i class="fa fa-calendar-day"></i> {{ $I18n.t('disponibilidad') }}
        </a>
        <a
          v-if="accesoConsulta"
          href="/guardias/consultas/estadisticas"
          class="btn btn-sm btn-default pull-right m-r-xs"
        >
          <i class="fa fa-chart-bar"></i> {{ $I18n.t('Consulta') }}
        </a>
        <a class="btn btn-sm btn-cifra pull-right m-r-xs" @click="mostrarFormFiltros">
          <i class="far fa-search"></i> {{ $I18n.t('Filtrar') }}
        </a>
      </h2>
      <transition
        enter-active-class="animated fadeInDown"
        leave-active-class="animated fadeOutUp"
      >
        <div v-if="labelsFiltros.length" class="m-t-xs">
          <span class="m-r-xs">{{ $I18n.t('filtros_aplicados') }}:</span>
          <div
            v-for="label in labelsFiltros"
            :key="label.id"
            class="label label-default m-r-xs clickable"
            @click.prevent="eliminarFiltro(label)"
          >
            {{ label.nombre }}
            <i class="m-l-xs fa fa-times font-12x"></i>
          </div>
        </div>
      </transition>
    </div>
    <calendario
      ref="calendario"
      class="m-t"
      :puede-anadir="editable"
      :slot-todo-el-dia="false"
      :seleccionable="false"
      :event-source="eventSource"
      @event-render="eventRender"
      @event-new="eventNew"
      @event-click="eventEdit"
    />
    <ModalSimple
      v-if="editable"
      v-model="showModalGuardia"
      :titulo="$I18n.t('registro_guardias')"
      tamano="lg"
    >
      <form-guardias
        v-if="showModalGuardia"
        @cancelado="cerrarModal"
        @guardado="cerrarModal"
        @eliminado="cerrarModal"
      />
    </ModalSimple>
    <ModalSimple
      id="modal-guardia-edit"
      v-model="showModalGuardiaEdit"
    >
      <form-guardia-edit
        v-if="guardiaEditar && showModalGuardiaEdit"
        :disabled="!editable"
        :guardia="guardiaEditar"
        @cancelado="cerrarModalEdit"
        @eliminado="cerrarModalEdit"
      />
    </ModalSimple>
    <ModalSimple v-model="showModalFiltros">
      <div v-if="showModalFiltros">
        <div class="titulo-seccion m-t-none">
          {{ $I18n.t('Filtros') }}
        </div>
        <div class="form-group">
          <label for="" class="input-label">
            {{ $I18n.t('causa') }}
          </label>
          <select-cifra
            v-model="causa"
            :options="causas"
            :placeholder="$t('Seleccione')"
            :searchable="false"
            label="name"
            track-by="value"
            class="selector"
          />
        </div>
        <div class="form-group">
          <label for="" class="input-label">
            {{ $I18n.t('tipo_guardia') }}
          </label>
          <select-cifra
            v-model="tipo"
            :options="tipos"
            :placeholder="$t('Seleccione')"
            :searchable="false"
            label="name"
            track-by="value"
            class="selector"
          />
        </div>
        <div class="form-group">
          <SelectorEstructura
            ref="selectorEstructura"
            :valores-iniciales="filtroEstructuraInicial"
            :tipos-seleccionables="TIPOS_ESTRUCTURA_SELECCIONABLES"
            :namespace-parametros="false"
            class="selector-sm"
          ></SelectorEstructura>
        </div>
        <div class="form-group">
          <InputCheckboxBoolean
            v-model="asignacionVista"
            tipo="switch"
          >
            {{ $t('asignacion_vista') }}
          </InputCheckboxBoolean>
        </div>
        <div class="form-actions">
          <button class="btn btn-default" @click.prevent="ocultarModalFiltros">
            {{ $I18n.t('Cancelar') }}
          </button>
          <button type="button" class="btn btn-cifra" @click.prevent="filtrar">
            {{ $I18n.t('Aceptar') }}
          </button>
        </div>
      </div>
    </ModalSimple>
  </div>
</template>

<script>
import { usuarios } from 'cifra-api-js';
import SelectorEstructura from '@/components/SelectorEstructura.vue';
import ModalSimple from '@/components/ModalSimple.vue';
import { URL_GUARDIAS_CALENDAR } from '../../../api/cifra/guardias/guardias';
import { renderExtraData } from '../../../libs/cifra/fullcalendar';
import FormGuardias from './FormGuardias.vue';
import FormGuardiaEdit from './FormGuardiaEdit.vue';

const TIPOS_ESTRUCTURA_SELECCIONABLES = ['ensennanza', 'curso'];

export default {
  components: {
    SelectorEstructura, FormGuardias, FormGuardiaEdit, ModalSimple,
  },
  props: {
    editable: { type: Boolean, default: false },
    accesoConsulta: { type: Boolean, default: false },
    accesoDisponibilidad: { type: Boolean, default: false },
  },
  data() {
    return {
      TIPOS_ESTRUCTURA_SELECCIONABLES,
      guardiaEditar: null,
      tipo: null,
      asignacionVista: false,
      tipos: [
        { name: this.$I18n.t('ordinaria'), value: 'ordinaria' },
        { name: this.$I18n.t('Extraordinaria'), value: 'extraordinaria' },
      ],
      causa: null,
      causas: [
        { name: this.$I18n.t('lectiva'), value: 'lectiva' },
        { name: this.$I18n.t('personal'), value: 'personal' },
      ],
      filtros: {},
      showModalGuardia: false,
      showModalGuardiaEdit: false,
      showModalFiltros: false,
    };
  },
  computed: {
    filtroEstructuraInicial() {
      const valor = {};
      TIPOS_ESTRUCTURA_SELECCIONABLES.forEach((tipo) => {
        if (this.filtros[tipo]) {
          valor[tipo] = this.filtros[tipo].id;
        } else {
          valor[tipo] = undefined;
        }
      });
      return valor;
    },
    labelsFiltros() {
      const labels = [];
      if (this.filtros.tipo) {
        labels.push({
          id: 'tipo',
          nombre: this.filtros.tipo.name,
        });
      }
      if (this.filtros.causa) {
        labels.push({
          id: 'causa',
          nombre: this.filtros.causa.name,
        });
      }
      if (this.filtros.asignacionVista) {
        labels.push({
          id: 'asignacionVista',
          nombre: this.$I18n.t('asignacion_vista'),
        });
      }
      TIPOS_ESTRUCTURA_SELECCIONABLES.forEach((tipo) => {
        const datos = this.filtros[tipo];
        if (datos) {
          labels.push({
            id: tipo,
            nombre: datos.etiqueta || datos.nombre,
          });
        }
      });

      return labels;
    },
    eventSource() {
      let url = `${URL_GUARDIAS_CALENDAR}?1=1`;
      if (this.filtros.tipo) {
        url = `${url}&tipo=${this.filtros.tipo.value}`;
      }
      if (this.filtros.causa) {
        url = `${url}&causa=${this.filtros.causa.value}`;
      }
      if (this.filtros.asignacionVista) {
        url = `${url}&asignacion_vista=${this.asignacionVista}`;
      }
      TIPOS_ESTRUCTURA_SELECCIONABLES.forEach((tipo) => {
        const datos = this.filtros[tipo];
        if (datos) {
          url = `${url}&${tipo}_id=${datos.id}`;
        }
      });

      return url;
    },
  },
  watch: {
    filtros: {
      handler(_val) {
        this.getCalendar().refetchEvents();
      },
      deep: true,
    },
  },
  methods: {
    fullname: usuarios.fullname,
    eventNew() {
      if (!this.editable) return;

      this.showModalGuardia = true;
    },
    eventEdit(info) {
      this.guardiaEditar = {
        id: info.event.id,
        ...info.event.extendedProps,
      };
      this.showModalGuardiaEdit = true;
    },
    eventRender(arg) {
      renderExtraData(arg);
    },
    cerrarModal() {
      this.showModalGuardia = false;
      this.getCalendar().refetchEvents();
    },
    cerrarModalEdit() {
      this.showModalGuardiaEdit = false;
      this.getCalendar().refetchEvents();
    },
    mostrarFormFiltros() {
      this.tipo = this.filtros.tipo;
      this.causa = this.filtros.causa;
      this.asignacionVista = this.filtros.asignacionVista;
      this.showModalFiltros = true;
    },
    filtrar() {
      this.filtros.tipo = this.tipo;
      this.filtros.causa = this.causa;
      this.filtros.asignacionVista = this.asignacionVista;
      const estructura = this.$refs.selectorEstructura.getPathSeleccionadoEnHash();
      if (estructura) {
        TIPOS_ESTRUCTURA_SELECCIONABLES.forEach((tipo) => {
          this.filtros[tipo] = estructura[tipo];
        });
      }
      this.ocultarModalFiltros();
    },
    ocultarModalFiltros() {
      this.showModalFiltros = false;
    },
    eliminarFiltro(label) {
      this.filtros[label.id] = undefined;
    },
    getCalendar() {
      return this.$refs.calendario.getCalendar();
    },
  },
};
</script>

<style lang="css" scoped>
:deep(.selector) {
  z-index: 2000;
}
</style>
